import styled from 'styled-components'
import { FONT } from '../../../../../../../../../../utils'

export const Text = styled.div`
   ${FONT({ weight: '500', size: '14px' })}
`
